/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  TrashIcon,
} from '@vgrubs/components';
import { HolidayHoursReponseV2 } from 'components/src/types/location.types';
import { Dispatch, SetStateAction } from 'react';

export const DeleteHolidayHours = ({
  modalIsOpen,
  closeModal,
  setHolidayHours,
}: PropsModal & {
  setHolidayHours: Dispatch<SetStateAction<HolidayHoursReponseV2[]>>;
  modalIsOpen: {
    index: number;
  } | null;
}) => {
  const { index } = modalIsOpen || {};

  async function handleDelete() {
    if (!index) return;

    setHolidayHours((prev) => {
      return prev.filter((_, i) => i !== index - 1);
    });

    closeModal?.();
  }

  return (
    <Modal isOpen={!!modalIsOpen} closeModal={closeModal} logo={false}>
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Holiday Hour?</H3>
      <P $mb="16">Are you sure you want to delete this holiday hour?</P>

      <Div $flex $gap="20px">
        <Div $width="50%">
          <Button $selected $w="100%" $mt="24" onClick={handleDelete}>
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button
            $selected
            $gray
            $w="100%"
            $mt="24"
            onClick={() => closeModal?.()}
          >
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
